import validator from 'validator';

interface PasswordOptions {
  minLength?: number;
}

export const isValidPassword = (
  password: string,
  options: PasswordOptions = { minLength: 10 }
): boolean => {
  if (!password || password.includes(' ')) return false;
  return validator.isStrongPassword(password, options);
};
